/**
 * 文件工具函数
 */

/**
 * 从URL中提取文件名
 * @param {string} url - 文件URL
 * @returns {string|null} 提取的文件名，失败返回null
 */
export function extractFileNameFromUrl(url) {
  if (!url) return null;
  try {
    let fileName = '';
    
    try {
      const urlObj = new URL(url);
      fileName = urlObj.pathname.split('/').pop();
    } catch (e) {
      const parts = url.split('/');
      fileName = parts[parts.length - 1];
    }
    
    fileName = fileName.split('?')[0];
    
    fileName = decodeURIComponent(fileName);
    
    const firstDotIndex = fileName.indexOf('.');
    if (firstDotIndex !== -1 && firstDotIndex < fileName.length - 1) {
      fileName = fileName.substring(firstDotIndex + 1);
    }
    
    return fileName;
  } catch (e) {
    console.error('提取文件名失败:', e);
    return null;
  }
}

/**
 * 规范化简历文件名
 * 优先使用传入的文件名，其次从URL提取，最后使用默认值
 * @param {string} resumeUrl - 简历URL
 * @param {string} resumeName - 简历名称（可选）
 * @param {string} defaultName - 默认文件名（可选，默认为"微信上传简历.pdf"）
 * @returns {string} 规范化后的文件名
 */
export function normalizeResumeFileName(resumeUrl, resumeName = '', defaultName = '微信上传简历.pdf') {
  let fileName = resumeName;
  
  // 如果没有传入文件名，尝试从URL提取
  if (!fileName) {
    fileName = extractFileNameFromUrl(resumeUrl);
  }
  
  // 如果还是没有或者是 'undefined'，使用默认值
  if (!fileName || fileName === 'undefined') {
    fileName = defaultName;
  }
  
  // 确保文件名有扩展名
  if (!fileName.includes('.')) {
    fileName += '.pdf';
  }
  
  return fileName;
}

/**
 * 规范化岗位要求文件名
 * @param {string} jdUrl - 岗位要求URL
 * @param {string} jdName - 岗位要求名称（可选）
 * @param {string} defaultName - 默认文件名（可选，默认为"微信上传岗位要求.pdf"）
 * @returns {string} 规范化后的文件名
 */
export function normalizeJDFileName(jdUrl, jdName = '', defaultName = '微信上传岗位要求.pdf') {
  return normalizeResumeFileName(jdUrl, jdName, defaultName);
}

